export const TestIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
        <path
            d="M10.425 5a.632.632 0 1 0 0 1.263h.211v4.968a1.894 1.894 0 0 1-.337 1.078L6.34 18.026a1.905 1.905 0 0 0 .16 2.356A1.956 1.956 0 0 0 7.964 21H19.2a1.955 1.955 0 0 0 1.465-.617 1.905 1.905 0 0 0 .16-2.356l-3.958-5.717a1.894 1.894 0 0 1-.337-1.078V6.263h.211A.632.632 0 1 0 16.74 5h-6.315ZM11.9 6.263h3.368v3.368H11.9Zm.421 7.579a.842.842 0 1 1-.842.842.842.842 0 0 1 .84-.842Zm3.579 2.526a1.053 1.053 0 1 1-1.053 1.053 1.052 1.052 0 0 1 1.053-1.053Z"
            transform="translate(-2.006 -1)"
            fill="#fff"
            data-name="Group 113207"
        />
    </svg>
)